import React from 'react';
import { Container, Box } from '@mui/material';
import Register from '../components/Auth/Register';

const RegisterPage = () => {
  return (
    <Container>
      <Box sx={{ my: 4 }}>
        <Register />
      </Box>
    </Container>
  );
};

export default RegisterPage;